import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listCentros:[],
  listCentrosCatalogo:[],
  newCentros:[],
  selectCentros:[],
  dataCentros:[],
  centros_id:[]
};
export const mutations = {
  GET_CENTROS_CATALOGO({ context }, listCentrosCatalogo) {
    state.loading = false;
    if (listCentrosCatalogo) {
      let centros = [];
      Object.entries(listCentrosCatalogo).forEach(([key, val]) => centros.push(val));
      return (state.listCentrosCatalogo = centros);
    }
  },

  GET_CENTROS({ context }, listCentros) {
    state.loading = false;
    if (listCentros) {
      let centros = [];
      Object.entries(listCentros).forEach(([key, val]) => centros.push(val));
      return (state.listCentros = centros);
    }
  },

  SELECT_CENTROS({ context }, centros) {
    state.selectCentros = Object.assign({}, centros);
  },

  SAVE_CENTRO({ context }, data) {
    state.newCentro = Object.assign({}, data);
  },

  EDIT_CENTRO({ context }, dataCentro) {
    state.dataCentro = Object.assign({}, dataCentro);
  },

  DELETE_CENTRO({ context }, centro_id) {
    state.centro_id = Object.assign({}, centro_id);
  },

};
export const actions = {
  GET_CENTROS_CATALOGO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("GET_CENTROS_CATALOGO", response.data.centros);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_CENTROS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("GET_CENTROS", response.data.centros);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SELECT_CENTROS({ commit }) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.selectCentros()
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("SELECT_CENTROS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_CENTRO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("SAVE_CENTRO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  EDIT_CENTRO({ commit }, data) { //axios, mandar parametros para post
    //console.log(data);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(data)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("EDIT_CENTRO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  DELETE_CENTRO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      console.log(data);
      ApiService.delete(data)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("DELETE_CENTRO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }

};
export const getters = {//leer datos
  listCentrosCatalogo: state => state.listCentrosCatalogo,
  listCentros: state => state.listCentros,
  selectCentros: tate => state.selectCentros,
  newCentro: state => state.newCentro,
  dataCentro: state => state.dataCentro,
  centro_id: state => state.centro_id
};
